import React from 'react'

export default function WalletNav(props: React.SVGProps<SVGSVGElement>): React.ReactElement {
  return <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="#747894" {...props}>
    <path d="M21 12V7H5a2 2 0 0 1 0-4h14v4" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M3 5v14a2 2 0 0 0 2 2h16v-5" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M18 12a2 2 0 0 0 0 4h4v-4h-4z" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
}
